import { BrokerAgreementBorrower } from '../../../../../../queries/brokerAgreementQueries';
import { BorrowerContactDetails } from './components/BorrowerContactDetails';
import { BorrowerNetWorth } from './components/BorrowerNetWorth';
import { CardSectionLabel } from '../../../../../CardSectionLabel';

/** The agreement's borrower: its contact details, with its net worth beside them. */
export const AgreementBorrowerDetails = ({ borrower }: { borrower: BrokerAgreementBorrower }) => {
    return (
        // Three parts of the card's row to the broker's two (overrides borrowerSelectorCardColumns' equal columns)
        <div style={{ flex: '3 1 0' }}>
            <CardSectionLabel>Borrower:</CardSectionLabel>
            <div className='borrowerSelectorCardColumns'>
                <BorrowerContactDetails borrower={borrower} />
                <BorrowerNetWorth borrower={borrower} />
            </div>
        </div>
    );
};
